fragment NewsletterStubFragment on Campaign {
    id
    name
    htmlUrlPath
    creatorUser {
        id
        name
    }
    createdTime
    editions {
        totalCount
    }
    lastSentEdition {
        id
        name
        sendTime
    }
    type
    deletedTime
    modifiedTime
    engagementStats {
        totalSentCount
        replyRate
        replyCount
        clickCount
        clickRate
        openCount
        openRate
        permanentBounceRate
        permanentBounceCount
        unsubscribeRate
        unsubscribeCount
    }
}
